/* ==========================================================================
   SIMPS — Header cart icon behaviour (Torani model)
   --------------------------------------------------------------------------
     Add to cart          -> Recharge side drawer  (unchanged, Recharge's job)
     Header icon, click   -> navigates to /cart
     Header icon, Opt+click -> opens the side drawer (deliberate escape hatch)
     Header icon, Cmd+click -> /cart in a new tab

   WHY THIS WORKS WITHOUT EDITING THE HEADER
     Halo opens its cart drawers with DELEGATED jQuery handlers bound to
     $(document):  $doc.on('click', '[data-cart-sidebar]', ...)
     A delegated handler cannot run until the event has bubbled up to document.
     A listener registered on document in the CAPTURE phase runs BEFORE that,
     on the way down. So we intercept first and decide what happens.

     That means we never touch sections/header-nav-multi-site.liquid (181KB,
     theme-editor managed) and we never flip the quick_cart setting — which is
     what forced the all-or-nothing choice, because Recharge rides on the
     quick-cart mechanism for its own drawer. LEAVE quick_cart ENABLED.
   ========================================================================== */

(function () {
  'use strict';

  var TRIGGERS = [
    '[data-cart-sidebar]',
    '[data-open-cart-popup]'
  ].join(',');

  var CART_URL = (window.routes && window.routes.cart) || '/cart';

  function closestTrigger(el) {
    while (el && el !== document) {
      if (el.nodeType === 1 && el.matches && el.matches(TRIGGERS)) return el;
      el = el.parentNode;
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    var trigger = closestTrigger(event.target);
    if (!trigger) return;

    // Leave anything inside an already-open drawer alone — we only want the
    // HEADER icon, not the mini-cart's own controls.
    if (trigger.closest && trigger.closest('#halo-cart-sidebar, [data-quick-cart-popup], #halo-quick-cart-popup')) return;

    // OPTION/ALT-CLICK = deliberate escape hatch to the drawer.
    //
    // On macOS, Option-click means "download this link". Because fixHrefs sets
    // href="/cart" on the icon, an unguarded Option-click downloaded the cart
    // page as cart.html (687KB). preventDefault stops that. We then return
    // WITHOUT stopping propagation, so Halo/Recharge's delegated handler still
    // runs and the side drawer opens — which is the behaviour we want here.
    var altOnly = event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0;
    if (altOnly) {
      event.preventDefault();
      return;
    }

    // Capture phase: runs before Halo's document-level delegated handler, so
    // stopImmediatePropagation prevents the drawer from opening for every other
    // kind of click.
    event.stopImmediatePropagation();

    // Cmd-click, Shift-click and middle-click keep their normal meanings. We do
    // NOT preventDefault, so the anchor's href opens /cart in a new tab or
    // window as the browser sees fit.
    var modified = event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0;
    if (modified) return;

    // Plain left click: go to the cart page.
    event.preventDefault();
    window.location.href = CART_URL;
  }, true); // <-- true = capture phase. The whole trick is this argument.

  // If the icon is an anchor, point its href at the cart page so middle-click
  // and "open in new tab" land somewhere sensible.
  function fixHrefs() {
    var nodes = document.querySelectorAll(TRIGGERS);
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.tagName === 'A' && (!n.closest || !n.closest('#halo-cart-sidebar, [data-quick-cart-popup]'))) {
        n.setAttribute('href', CART_URL);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixHrefs);
  } else {
    fixHrefs();
  }
})();
